Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.RefreshIntervalPickerView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/refresh_interval_picker']

  initialize: ({refreshInterval, chosen = false, width}) ->
    @refreshInterval = refreshInterval
    @chosen = chosen
    @width = width
    @listenTo(@refreshInterval, 'change', @_updateSelectedOption)

  render: ->
    @$el.html @template
      refreshIntervalOptions: @refreshInterval.get('options')
    @_updateSelectedOption()
    @_selector().chosen(disable_search: true, width: @width) if @chosen
    @_selector().on 'change', (event) =>
      @refreshInterval.set({selectedOption: Number(event.target.value)})
    @

  _updateSelectedOption: ->
    @_selector().val(@refreshInterval.get('selectedOption'))

  _selector: ->
    @$('.refresh-interval-in-seconds')
